import React from "react";
import {
  FormGroup,
  Input,
  Label,
  FormFeedback,
  Row,
  Col,
  Button,
} from "reactstrap";
import RememberMeComp from "../../AuthHelpers/RememberMeComp";
import { Link } from "react-router-dom";
import client from "../../../../client";
import config from "../../../../config";
import RenderIcon from "../../../commons/RenderIcon";
import OTPScreen2 from "./OtpScreen2";

class Template6 extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      email: "",
      password: "",
      isChecked: false,
      isShowPassword: false,
      twoFAStatus: null,
    };
  }

  updateTwoFAStatus = (t) => {
    this.setState({ twoFAStatus: t });
  };
  onLogin = () => {
    const { email, password, isChecked } = this.state;
    const { authenticationCallback, itemProperties, sessionId, twoFA } =
      this.props;
    if (isChecked && email !== "") {
      localStorage.username = email;
      localStorage.password = password;
      localStorage.checkbox = isChecked;
    }
    const payload = {
      email,
      password,
    };

    if (twoFA) {
      this.props.setError(false);
      this.props.login(payload, () => {
        const otpPayload = {
          phoneNumber: email,
        };
        // client().post(`${config.publicAPI}/generateotp`, otpPayload).then((res) => {
        // }).catch((error) => {
        //   this.updateTwoFAStatus(null)
        // });
        this.updateTwoFAStatus("OTP");
      });
    } else {
      if (itemProperties && itemProperties.authenticateUsingPlugins) {
        payload["authenticateUsingPlugins"] = true;
        payload["sessionId"] = sessionId;
      }
      this.props.setError(false);
      this.props.login(payload, authenticationCallback);
    }
  };

  togglePasswordVisiblity = () => {
    this.setState({ isShowPassword: !this.state.isShowPassword });
  };
  render() {
    const {
      label,
      hasForgotPassword,
      authTemplate3SideImageUrlComplete,
      authTemplateTopFormText,
      companyDetails,
      companySettings,
      logoUrlComplete,
      authTemplateSideImageUrlComplete,
      authTemplateBackgroundColor,
      authTemplateFontColor,
      reActivateUser, 
      reActivateUserEmailDisable
    } = this.props;

    const { itemProperties, authenticationCallback, customIcons } = this.props;

    const rememberMe =
      itemProperties &&
      itemProperties.authConfig &&
      itemProperties.authConfig.rememberMe;

    const showPassword =
      itemProperties &&
      itemProperties.authConfig &&
      itemProperties.authConfig.showPassword;

    const sideImageTextOne = itemProperties && itemProperties.sideImageTextOne;
    const sideImageTextTwo = itemProperties && itemProperties.sideImageTextTwo;

    const sideImageTopLogo =
      itemProperties &&
      itemProperties.sideImageTopLogo &&
      itemProperties.sideImageTopLogo.path;

    const topHeadingLogo =
      itemProperties &&
      itemProperties.topHeadingLogo &&
      itemProperties.topHeadingLogo.path;  

    const hideOtpScreenText =
      itemProperties && itemProperties.hideOtpScreenText;
    const otpScreenLabel = itemProperties && itemProperties.otpScreenLabel;

    const sideImageTopLogoUrl = `${config.assetsBasePath}${sideImageTopLogo}`;
    const topHeadingLogoUrl = `${config.assetsBasePath}${topHeadingLogo}`;

    const emailIconConfig = {
      cssClass:
        itemProperties && itemProperties.cssEmailClass
          ? itemProperties.cssEmailClass
          : "fa-user",
      cssClass2:
        itemProperties && itemProperties.cssEmailClass
          ? itemProperties.cssEmailClass
          : "fa-user",
      cssCustomIconMenu:
        itemProperties && itemProperties.cssEmailClass
          ? itemProperties.cssEmailCustomWeb
          : null,
      webIconSizeMenu:
        itemProperties && itemProperties.cssEmailClass
          ? itemProperties.cssEmailCustomWebSize
          : null,
    };

    const passwordIconConfig = {
      cssClass:
        itemProperties && itemProperties.cssEmailClass
          ? itemProperties.cssPasswordClass
          : "fa-lock",
      cssClass2:
        itemProperties && itemProperties.cssEmailClass
          ? itemProperties.cssPasswordClass
          : "fa-lock",
      cssCustomIconMenu:
        itemProperties && itemProperties.cssEmailClass
          ? itemProperties.cssPasswordCustomWeb
          : null,
      webIconSizeMenu:
        itemProperties && itemProperties.cssEmailClass
          ? itemProperties.cssPasswordCustomWebSize
          : null,
    };

    const forgotPasswordConfig = {
      cssClass:
        itemProperties &&
        itemProperties.authConfig &&
        itemProperties.authConfig.forgotIcon
          ? itemProperties.authConfig.forgotIcon
          : null,
      cssClass2:
        itemProperties &&
        itemProperties.authConfig &&
        itemProperties.authConfig.forgotIcon
          ? itemProperties.authConfig.forgotIcon
          : null,
      cssCustomIconMenu:
        itemProperties &&
        itemProperties.authConfig &&
        itemProperties.authConfig.forgotCustomIcon
          ? itemProperties.authConfig.forgotCustomIcon
          : null,
      webIconSizeMenu:
        itemProperties &&
        itemProperties.authConfig &&
        itemProperties.authConfig.forgotCustomIconSize
          ? itemProperties.authConfig.forgotCustomIconSize
          : null,
    };

    return (
      <div className="login-template-6">
        <div
          className="left-panel"
          style={{
            backgroundImage: authTemplateBackgroundColor
              ? authTemplateBackgroundColor
              : "linear-gradient(to bottom, #1345a6 30%, #2da5da)",
          }}
        >
          {sideImageTopLogoUrl && (
            <img src={sideImageTopLogoUrl} className="left-logo" />
          )}
          <div className="left-para-sec">
            <p>
              {sideImageTextOne} <span>{sideImageTextTwo}</span>
            </p>
          </div>
          {authTemplateSideImageUrlComplete && (
            <img
              src={authTemplateSideImageUrlComplete}
              alt="payment-img"
              className="payment-bg-img"
            />
          )}
        </div>
        <div className="right-panel">
          <div
            className={`inner-right-panel ${
              this.state.twoFAStatus == "OTP" ? "inner-right-panel2" : ""
            }`}
          >
            <div
              className={`brand-logo ${
                this.state.twoFAStatus == "OTP" ? "text-center" : ""
              }`}
            >
              {topHeadingLogoUrl && <img src={topHeadingLogoUrl} alt="Image" />}
            </div>

            <div
              className={`heading-sec ${
                this.state.twoFAStatus == "OTP" ? "text-center" : ""
              }`}
            >
              {this.state.twoFAStatus === "OTP" ? (
                <>
                  {!hideOtpScreenText && (
                    <h3>
                      {otpScreenLabel ? otpScreenLabel : "One-Time Password"}
                    </h3>
                  )}
                </>
              ) : (
                <h3>{authTemplateTopFormText || "User Login"}</h3>
              )}
            </div>
            {this.state.twoFAStatus === "OTP" ? (
              <div className="otp-div">
                <OTPScreen2
                  authenticationCallback={authenticationCallback}
                  requiredRole={itemProperties.requiredRole}
                  phoneNumber={this.state.email}
                />
              </div>
            ) : (
              <div className="login-div">
                <div className="input-sec email">
                  <RenderIcon
                    config={emailIconConfig}
                    customIcons={customIcons}
                    customClassName="authIcons"
                  />
                  <Input
                    value={this.state.email}
                    required={true}
                    onChange={(event) =>
                      this.setState({ email: event.target.value })
                    }
                    onKeyDown={(event) => {
                      if (event.key === "Enter") {
                        event.preventDefault();
                        event.stopPropagation();
                        this.onLogin();
                      }
                    }}
                    placeholder={"Enter Email"}
                    type={"text"}
                  />
                  <div className="standard-line"></div>
                  <Label for={"email"}>
                    Email <span className="asterick-mark">*</span>
                  </Label>
                </div>
                <div className="input-sec">
                  <RenderIcon
                    config={passwordIconConfig}
                    customIcons={customIcons}
                    customClassName="authIcons"
                  />
                  <Input
                    value={this.state.password}
                    required={true}
                    onChange={(event) =>
                      this.setState({ password: event.target.value })
                    }
                    onKeyDown={(event) => {
                      if (event.key === "Enter") {
                        event.preventDefault();
                        event.stopPropagation();
                        this.onLogin();
                      }
                    }}
                    placeholder={"Enter Password"}
                    type={this.state.isShowPassword ? "text" : "password"}
                  />
                  <div className="standard-line"></div>
                  <Label for={"password"}>
                    Password <span className="asterick-mark">*</span>
                  </Label>
                  {showPassword && (
                    <div
                      className="password-show-btn"
                      role="button"
                      onClick={this.togglePasswordVisiblity}
                    >
                      <i
                        className={
                          this.state.isShowPassword
                            ? "fa fa-eye-slash"
                            : "fa fa-eye"
                        }
                        aria-hidden="true"
                      ></i>
                    </div>
                  )}
                </div>
                <div className="forgot-pass-link mb-3">
                  {rememberMe ? (
                    <div className="remember-me-login">
                      <RememberMeComp isCheckedProp={this.state.isChecked} />
                    </div>
                  ) : (
                    <div></div>
                  )}
                  {/* {hasForgotPassword ? (*/}
                  <div className="d-flex align-items-center">
                    <Link to="/app/forgotpassword">
                      <RenderIcon
                        config={forgotPasswordConfig}
                        customIcons={customIcons}
                      />
                      Forgot password?
                    </Link>

                    {reActivateUser && (
                      <>
                        <span className="mx-2">|</span>
                        <Link to={{
                          pathname: "/app/reactivateuser",
                          state: {
                            doNotSendEmail: reActivateUserEmailDisable
                          },
                        }}>
                          Reactivate User
                        </Link>
                      </>
                    )}
                  </div>
                  {/* ) : (
                    <div></div>
                  )} */}
                </div>
                <div>{this.props.reCaptchaComponent}</div>
                <Button
                  disabled={this.props.displayReCaptcha}
                  size="sm"
                  className="pr-2 pl-2 login-btn"
                  color="primary"
                  onClick={this.onLogin}
                >
                  {label.show ? label.text : "Login"}
                </Button>
              </div>
            )}
          </div>
        </div>
      </div>
    );
  }
}
export default Template6;
